import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({
  authed: null,
  user: null,
  login: async () => {},
  logout: async () => {},
});

export function AuthProvider({ children }) {
  const [authed, setAuthed] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onLogout = () => {
      setAuthed(false);
      setUser(null);
    };
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, []);

  useEffect(() => {
    api
      .get("/auth/status")
      .then((r) => {
        setAuthed(!!r.data.authed);
        setUser(r.data.user || null);
      })
      .catch(() => setAuthed(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    setAuthed(true);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setAuthed(false);
      setUser(null);
    }
  };

  return <AuthCtx.Provider value={{ authed, user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
